var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVelesfarming(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 770,
    height: 555,
    viewBox: "0 0 770 555",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 769,
    height: 554,
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_404_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.288 264.686H236.145L202.926 187.689H223.871L245.717 239.583L267.563 187.689H288.507L255.288 264.686V264.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.158 264.236H364.292V187.689H383.322V247.463H421.158V264.236V264.236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.241 211.441H542.098C541.084 205.7 537.481 201.76 529.711 201.76C523.18 201.76 518.788 204.461 518.788 209.414C518.788 213.579 521.829 215.381 527.572 216.619L538.269 219.095C552.232 222.135 561.354 227.763 561.354 240.934C561.354 256.243 548.742 265.812 529.598 265.812C512.37 265.812 496.83 257.707 495.028 238.795H514.059C515.297 245.549 521.153 249.602 530.162 249.602C537.256 249.602 540.972 247.013 540.972 242.847C540.972 240.258 539.395 237.557 532.864 236.318L520.252 233.504C505.163 230.24 498.069 223.148 498.069 210.99C498.069 195.681 510.455 186 528.472 186C540.859 186 559.327 190.84 561.241 211.441V211.441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.031 323.86H180.912V340.407H148.031V367.424H129V290.877H186.092V307.65H148.031V323.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.91 354.253L200.843 367.424H180.574L213.117 290.427H231.247L263.678 367.424H243.521L238.341 354.253H205.91V354.253ZM222.126 312.603L212.216 338.043H232.035L222.126 312.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.928 345.248V367.424H271.898V290.877H305.455C324.373 290.877 337.097 301.233 337.097 317.781C337.097 328.475 331.58 336.918 322.458 341.533L342.165 367.424H319.193L302.752 345.248H290.928ZM305.004 328.137C312.324 328.137 318.179 324.085 318.179 317.781C318.179 311.477 312.324 307.65 305.004 307.65H290.928V328.137H305.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.912 367.424H412.882V329.038L395.878 355.267V355.379H385.293V355.267L368.177 328.813L368.289 367.424H349.259V290.877H363.335L390.585 331.74L417.724 290.877H431.912V367.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.455 367.424H445.425V290.877H464.455V367.424V367.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.451 367.424H533.699L496.989 325.436V367.424H477.959V290.877H492.485L529.42 333.991V290.877H548.451V367.424V367.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 367.424H625.812L625.023 358.193C619.506 364.948 611.51 369 600.813 369C576.828 369 560.049 351.889 560.049 329.939C560.049 306.074 577.616 289.301 601.038 289.301C619.731 289.301 635.946 299.883 639.212 318.119H619.28C615.902 309.226 608.245 306.749 601.376 306.749C588.313 306.749 579.305 315.98 579.305 329.488C579.305 341.533 587.976 351.327 601.601 351.327C610.497 351.327 617.253 346.936 620.969 339.619L599.011 339.394V324.423H640V367.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.463 187.689H295.564V204.199H353.463V187.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.463 247.725H295.564V264.236H353.463V247.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.489 217.988H295.564V234.499H348.489V217.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.028 187.689H430.129V204.199H488.028V187.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.028 247.725H430.129V264.236H488.028V247.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.054 217.988H430.129V234.499H483.054V217.988Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_404_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 511,
    height: 183,
    fill: "white",
    transform: "translate(129 186)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVelesfarming);
export default __webpack_public_path__ + "static/media/velesfarming.cba2cc0729c39974bedc28178e42ece8.svg";
export { ForwardRef as ReactComponent };